import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String]) {
        shop(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
